import { milestones } from "@/mocks/about";

export default function TimelineSection() {
  return (
    <section className="py-20 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="mb-14">
          <div className="text-[#f59e0b] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Our Journey</div>
          <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight font-syne">10 Years of Building</h2>
        </div>
        <div className="relative">
          <div className="absolute left-4 lg:left-1/2 top-0 bottom-0 w-px bg-white/10 lg:-translate-x-px" />
          <div className="flex flex-col gap-0">
            {milestones.map((m, i) => (
              <div
                key={i}
                className={`relative flex flex-col lg:flex-row gap-6 lg:gap-0 pl-16 lg:pl-0 pb-12 ${i % 2 === 0 ? "lg:pr-[calc(50%+40px)]" : "lg:pl-[calc(50%+40px)]"}`}
              >
                <div className="absolute left-0 lg:left-1/2 top-1 lg:top-2 lg:-translate-x-1/2 w-8 h-8 flex items-center justify-center rounded-sm border border-[#00ff88]/40 bg-[#080808] z-10">
                  <span className="text-[#00ff88] text-[10px] font-black leading-none font-syne">{m.year.slice(2)}</span>
                </div>
                <div className="bg-[#0f0f0f] border border-white/5 rounded-sm p-6 hover:border-[#00ff88]/15 transition-all w-full">
                  <div className="text-[#00ff88] text-xs tracking-widest font-semibold mb-1 font-inter">{m.year}</div>
                  <h3 className="text-white font-bold text-lg mb-2 font-syne">{m.title}</h3>
                  <p className="text-white/40 text-sm leading-relaxed font-inter">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
